import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  forwardRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxComponent),
      multi: true,
    },
  ],
})
export class CheckboxComponent implements ControlValueAccessor {
  /**
   * Emits a checked event back to the parent component
   */
  @Output() checked: EventEmitter<boolean> = new EventEmitter();
  /**
   * Receives boolean if isReadonly
   */
  @Input() isReadonly = false;
  /**
   * Tracks state of checkbox
   */
  @Input() isChecked = false;
  /**
   * Receives boolean if isDisabled
   */
  @Input() isDisabled = false;

  private onTouched: () => void = () => {
    return undefined;
  };

  private onChanged: (_val: unknown) => void = () => {
    return undefined;
  };

  /**
   * Triggers when checkbox is clicked
   */
  onClick() {
    this.isChecked = !this.isChecked;
    this.checked.emit(this.isChecked);
    this.writeValue(this.isChecked);
  }

  registerOnChange(fn) {
    this.onChanged = fn;
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  writeValue(val) {
    this.onChanged(val);
    this.onTouched();
  }
}
